import React, { Component } from 'react'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'

import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
import SubPlansSection from '../components/subPlans/SubPlansSection';
import { Container, Row, Col, Image } from 'react-bootstrap'
import ShimmerLoader from '../components/preloader/ShimmerLoader';



const FETCH_ISSTUDENTUSERVALID = gql` 
query($student_user_exam_id: Int!) {
    isStudentUserValid(student_user_exam_id: $student_user_exam_id){
        estatus
        current_plan_id
        expiry_date
        app_version
        user_access_restictions
     }
}

`;


const FETCH_PLANS_NEW = gql`
query($student_user_exam_id: Int!){
        getSubscriptionPlans(student_user_exam_id: $student_user_exam_id) {
            id
            name
            exam_id
            student_plan_id
            order_by
            image_path
            description
            studentPlans{
                id
                plan_name
                plan_title
                amount
                exam_id
                original_amount
                valid_days
                image
                additional_text
                plan_features
                color
                coupon_display
                upgrade_access
                upgrade_amount
                upgrade_description
                expiry_date
          }
        }
}
`

const UPDATE_STUDENT_ANALYTICS = gql`
  mutation(
    $params:AnalyticsStudents1  
    ) {
        studentAnalytics(
        params: $params
     )
  }
`;
class SubPlans extends Component {
    constructor(props) {
        super(props)
        this.state = {
            submitError: ""

        }
    }
    componentDidMount = () => {

        this.addStudentAnalytics();

        const title = GoogleAnalyticsArray[0].Packages;
        ReactGA.pageview('/student/package', ["rizee"], title);
    }

    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 88,
            source: 2

        }


        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        const getSubscriptionPlans = this.props.getSubscriptionPlans;
        const loading4 = getSubscriptionPlans.loading;
        const error4 = getSubscriptionPlans.error


        const isStudentUserValid = this.props.isStudentUserValid;
        const loading5 = isStudentUserValid.loading;
        const error5 = isStudentUserValid.error;


        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }

        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }
        if (isStudentUserValid.isStudentUserValid != undefined) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                this.props.history.push("/student/login");
            }

        }


        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper bg-white scrolling">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        

                            {
                                loading4 == true && loading5 == true ?
                                (
                                    <Container>
                                        <Row>
                                            <Col sm={12}>
                                                <ShimmerLoader />
                                            </Col>
                                        </Row>
                                    </Container>
                                )
                                :
                                (
                                    <SubPlansSection
                                    isStudentUserValid={isStudentUserValid.isStudentUserValid}
                                    getSubscriptionPlans={getSubscriptionPlans.getSubscriptionPlans}
                                />
                                )
                            }

                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(compose(

    graphql(FETCH_ISSTUDENTUSERVALID,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                }
                ,
                // Shared cache entry; revalidated on navigation by utils/sessionValidity.
                fetchPolicy: "cache-first"
            }), name: "isStudentUserValid"
        }), 
    graphql(UPDATE_STUDENT_ANALYTICS, {
        name: "submitpt"
    }),
    graphql(FETCH_PLANS_NEW,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                }
                ,
                // Plans are static reference data; see EamcetRestrictionAlert.
                fetchPolicy: "cache-first"
            }), name: "getSubscriptionPlans"
        }),

)(SubPlans));
